import React from 'react';

import { Button, Pagination, Loading } from '@jdcfe/legao';

import { getUserInfo, querySearchTypes, queryCommonSearch, queryAuthPackList } from "utils/api";

import queryString from 'query-string';

import './style.scss';


class SearchContent extends React.Component {

    constructor() {
        super();

        this.state = {
            inputValue: queryString.parse(location.search).k ? queryString.parse(location.search).k : '',
            pageIndex: 1,
            total: 100,
            pageSize: 5,
            pageTotal: 5,
            loading: false,
            dataTypes: [],
            currType: 0,
            dataList: [],
            pin: ''
        };
    }

    async componentDidMount() {
        const res = await getUserInfo();
        if(res.data.success) {
            this.setState({
                pin: res.data.result.pin
            });
        }
        this.setState({
            loading: true,
        });
        console.log('state2', this.state)

        //搜索类别
        this.querySearchTypes();
    }

    //搜索类别
    async querySearchTypes() {
        try {
            const result = await querySearchTypes({ pin: this.state.pin, keyword: encodeURIComponent(this.state.inputValue) });
            if(result.data.resultCode == '0000') {
                this.setState({
                    dataTypes: result.data.result,
                    currType: result.data.result[0].type,
                    loading: false
                }, () => {
                    this.queryCommonSearch(result.data.result[0].type);
                });
            } else {
                this.setState({
                    loading: false
                })
            }
        } catch(e) {
            this.setState({
                loading: false
            })
        }
        
    }

    //搜索关键词
    async queryCommonSearch(type) {
        this.setState({
            loading: true
        });
        try {

            const res = await queryCommonSearch({
                pin: this.state.pin,
                type,
                keyword: this.getQueryVariable('k'),
                pageIndex: this.state.pageIndex,
                pageSize: this.state.pageSize
            });
    
            if(res.data.resultCode == '0000') {
                this.setState({
                    dataList: res.data.result.resList,
                    pageIndex: res.data.result.pageIndex,
                    pageSize: res.data.result.pageSize,
                    pageTotal: res.data.result.pageTotal,
                    total: res.data.result.pageItemTotal,
                    loading: false
                });
            } else {
                this.setState({
                    loading: false
                })
            }
        } catch(e) {
            this.setState({
                loading: false
            })
        }
    }
    
    goPage(index) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        this.setState({
            pageIndex: index
        }, () => {
            this.queryCommonSearch(this.state.currType);
        });
    }

    handleSearch() {
        location.href = `/search?k=${this.state.inputValue}`
    }

    handleKeyDown(e) {
        if(e.keyCode === 13) {
            location.href = `/search?k=${this.state.inputValue}`
        }
    }

    handleChange(e) {
        this.setState({
            inputValue: e.target.value
        });
    }

    handleTabClick(type) {
        this.setState({
            currType: type,
            pageIndex: 1
        }, () => {
            this.queryCommonSearch(type);
        });
    }

    handleClick(id, type, categoryid, appKey,hitStrings) {
        if(type == 2) {//文档
            window.open(`/doc/guide?id=${id}&k=${hitStrings.join(',')}`);
        } else if(type == 3) {//常见问题
            window.open(`/doc/faq?categoryid=${categoryid}&id=${id}&k=${hitStrings.join(',')}`);
        } else if(type == 4) {//通知改成平台公告
            window.open(`/notice/${id}?k=${hitStrings.join(',')}`);
        } else if(type == 5) {//API文档
            window.open(`/doc/api?id=${id}&k=${hitStrings.join(',')}`);
        } else if(type == 6) {//对接方案
            queryAuthPackList({
                appKey: appKey,
              }).then((res) => {
                if(res.data.result!=null){
                  const item = res.data.result[0]
                  window.open(`/app/frame/schemedetail?appKey=${appKey}&authId=${item.authPackId}&authPackName=${item.authPackName}&articleId=${id}&k=${this.state.inputValue}`);
                }
              });
        }
    }

    getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return "";
    }

    render() {
        let { pageIndex, total, pageSize, pageTotal, inputValue, dataTypes, currType, dataList, loading } = this.state;
        return (
            <React.Fragment>
                <div className="basic-layout-loading" style={{ 'display': loading ? 'block' : 'none' }}>
                    <Loading />
                </div>
                <div className="search-content">
                    <div className="search-top">
                        <input type="text" className="search-input" value={ inputValue } placeholder="关键词" onChange={ (e) => { this.handleChange(e) } } onKeyDown={ (e) => { this.handleKeyDown(e) } }/>
                        <Button styleType="primary" onClick={() => this.handleSearch()}>
                            <span className={`lg-btn-text`}>搜 索</span>
                        </Button>
                    </div>
                    <div className="search-tab">
                        <ul>
                            {
                                dataTypes && dataTypes.length>0  && dataTypes.map((item) => (
                                    <li className={ item.type === currType ? 'cur' : '' } key={ item.type } onClick={ () => { this.handleTabClick(item.type) } }>
                                        <span>{ item.value }</span>
                                        <span>({ item.count })</span>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
                <div className="search-list">
                    {
                        dataList && dataList.length
                        ?
                        dataList.map((item) => (
                            <div className="search-list-item" key={ item.id } onClick={ () => { this.handleClick(item.id, item.type, item.categoryId, item.appKey, item.hitStrings) } }>
                                <div className="title" dangerouslySetInnerHTML={ { __html:  item.highTitle } }></div>
                                <div className="desc" dangerouslySetInnerHTML={{ __html: item.highContent }}></div>
                                <div className="time">更新时间：{ item.updateTime }</div>
                            </div>
                        ))
                        :
                        <div className="nomore">未检索到数据</div>
                    }
                    <div className="search-list-page">
                        <Pagination
                            prefixCls={"lg"}
                            type={"basic"}
                            defaultCurrent={pageIndex}
                            total={total}
                            pageSize={pageSize}
                            viewSize={pageTotal}
                            hasChangeSize={false}
                            hasJump={true}
                            hasTotal={true}
                            onChange={(index, size) => {
                                this.goPage(index, size);
                            }}
                        />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default SearchContent;